import React, { useEffect, useState } from 'react';
import Title from './Title';
import { useDispatch, useSelector } from 'react-redux';
import { useFormNew } from '../../../../../hooks/useFormNew';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Button,
  Grid,
} from '@material-ui/core';
import { HCE_PERMISOS } from '../../../../../utils/permisos';
import { AREAS_USUARIOS } from '../../../../../utils/constants';
import { validarSoloUnPermiso } from '../../../../../helpers/permisos';
import { GenericModal } from '../../../../atomic/organisms/GenericModal';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import {
  postSignosVitales,
  traerSignosVitales,
} from '../../../../../actions/hce/hceActions';
import { SignosVitalesItem } from './SignosVitalesItem';

export const CardSignosVitales = ({ hce }) => {
  const { permisos: permisosUser, areas } = useSelector((state) => state.auth);
  const { signosVitales, disabled } = useSelector((state) => state.hce);
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(traerSignosVitales(hce.idAfiliado, hce.idAfiliadoExterno));
  }, []);

  const initialValues = {
    idAfiliado: hce?.idAfiliado ? hce.idAfiliado : 0,
    idAfiliadoExterno: hce?.idAfiliadoExterno,
    peso: '',
    talla: '',
    imc: '',
    frecCardiaca: '',
    taSistolica: '',
    taDiastolica: '',
    perCefalico: '',
    perCintura: '',
    tempCorporal: '',
    frecRespiratoria: '',
    saturacionOxigeno:'',
    idEfector: hce?.idEfector,
  };
  const { formValues, handleInputChange, reset, setearValor } = useFormNew(initialValues);

  const calcularIMC = () => {
    const peso = parseFloat(formValues.peso);
    const talla = parseFloat(formValues.talla);

    if (!isNaN(peso) && !isNaN(talla) && talla !== 0) {
      const imc = peso / ((talla / 100) ** 2); // Convertir la talla a metros
      setearValor("imc", imc.toFixed(2));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(postSignosVitales({ ...formValues }, setModal));
    reset();
  };

  return (
    <>
      <Title>
        Signos Vitales{' '}
        {validarSoloUnPermiso(
          permisosUser,
          HCE_PERMISOS.HCE,
        ) &&
          areas.filter((area) => area.idArea === AREAS_USUARIOS.CENTROS_MEDICOS)
            .length > 0 && (
            <>
              {!disabled &&
                <Button
                  disabled={disabled}
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    setModal(true);
                  }}
                >
                  + Ingresar Signos Vitales
                </Button>
              }
            </>
          )}
      </Title>
      {Array.isArray(signosVitales) && signosVitales?.length > 0 ? (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '10%' }}>Fecha</TableCell>
              <TableCell style={{ width: '10%' }}>{'Peso (kg)'}</TableCell>
              <TableCell style={{ width: '10%' }}>{'Talla (cm)'}</TableCell>
              <TableCell style={{ width: '10%' }}>{'IMC'}</TableCell>
              <TableCell style={{ width: '10%' }}>
                {'Frecuencia Cardíaca (lpm)'}
              </TableCell>
              <TableCell style={{ width: '10%' }}>
                {'TA (mmgh)'}
              </TableCell>
              <TableCell style={{ width: '10%' }}>
                {'TA (mmgh)'}
              </TableCell>
              <TableCell style={{ width: '10%' }}>
                {'PER Cefalico (cm)'}
              </TableCell>
              <TableCell style={{ width: '10%' }}>
                {'PER Cintura (cm)'}
              </TableCell>
              <TableCell style={{ width: '10%' }}>
                {'Temperatura Corporal (°C)'}
              </TableCell>
              <TableCell style={{ width: '10%' }}>
                {'Frecuencia respiratoria'}
              </TableCell>
              <TableCell style={{ width: '10%' }}>
                {'Saturación oxígeno'}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {signosVitales.map((signoVital, index) => {
              return (
                <SignosVitalesItem
                  key={signoVital?.id.toString()}
                  signoVital={signoVital}
                />
              );
            })}
          </TableBody>
        </Table>
      ) : (
        <Typography style={{ fontSize: '1.1rem', fontStyle: 'italic' }}>
          No hay Signos Vitales Registrados
        </Typography>
      )}
      {modal && (
        <GenericModal
          open={modal}
          closeModal={() => {
            setModal(false);
          }}
          title={'Agregar signos vitales'}
          gridStyle={{ textAlign: 'center', padding: '1em' }}
          maxWidth="sm"
        >
          <ValidatorForm onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={4} sm={3} md={3} lg={3}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Peso"
                  autoComplete="off"
                  name="peso"
                  type="number"
                  validators={['isNumber']}
                  errorMessages={['Solo números']}
                  value={formValues.peso}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={4} sm={3} md={3} lg={3}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Talla"
                  autoComplete="off"
                  name="talla"
                  type="number"
                  validators={['isNumber']}
                  errorMessages={['Solo números']}
                  value={formValues.talla}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={4} sm={3} md={3} lg={3}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Imc"
                  autoComplete="off"
                  name="imc"
                  type="number"
                  value={formValues.imc}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={4} sm={2} md={2} lg={2}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ marginTop: '1.5rem' }}
                  onClick={calcularIMC}
                >
                  Calcular
                </Button>
              </Grid>

              <Grid item xs={4} sm={4} md={4} lg={4}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Frecuencia Cardiaca"
                  autoComplete="off"
                  name="frecCardiaca"
                  type="number"
                  validators={['isNumber']}
                  errorMessages={['Solo números']}
                  value={formValues.frecCardiaca}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={4} sm={1} md={1} lg={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography>TA</Typography>
              </Grid>
              <Grid item xs={4} sm={3} md={3} lg={3}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  //label="Tensíon arterial"
                  autoComplete="off"
                  name="taSistolica"
                  type="number"
                  validators={['isNumber']}
                  errorMessages={['Solo números']}
                  value={formValues.taSistolica}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              {/* <Grid item xs={4} sm={1} md={1} lg={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}> */}
                <span style={{ fontSize: '1.5rem', fontWeight: 'bold', marginTop: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>⁄</span>
              {/* </Grid> */}
              <Grid item xs={4} sm={3} md={3} lg={3}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  //label="Tensíon arterial"
                  autoComplete="off"
                  name="taDiastolica"
                  type="number"
                  validators={['isNumber']}
                  errorMessages={['Solo números']}
                  value={formValues.taDiastolica}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="PER Cefalico"
                  autoComplete="off"
                  name="perCefalico"
                  type="number"
                  value={formValues.perCefalico}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="PER Cintura"
                  autoComplete="off"
                  name="perCintura"
                  type="number"
                  value={formValues.perCintura}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Temperatura Corporal"
                  autoComplete="off"
                  name="tempCorporal"
                  type="number"
                  value={formValues.tempCorporal}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Frecuencia respiratoria"
                  autoComplete="off"
                  name="frecRespiratoria"
                  type="number"
                  validators={['isNumber']}
                  errorMessages={['Solo números']}
                  value={formValues.frecRespiratoria}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid item xs={4} sm={4} md={4} lg={4}>
                <TextValidator
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  label="Saturación oxígeno"
                  autoComplete="off"
                  name="saturacionOxigeno"
                  type="number"
                  validators={['isNumber']}
                  errorMessages={['Solo números']}
                  value={formValues.saturacionOxigeno}
                  onChange={handleInputChange}
                  InputLabelProps={{ style: { fontWeight: 'bold' } }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                styles={{
                  display: 'flex',
                }}
              >
                <Button
                  variant="outlined"
                  style={{ marginRight: '1rem' }}
                  onClick={() => setModal(false)}
                >
                  Cancelar
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </ValidatorForm>
        </GenericModal>
      )}
    </>
  );
};
